var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.228,
    height: 22.435,
    viewBox: "0 0 18.228 22.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_365579",
    "data-name": "Path 365579",
    d: "M7.8,2h8.413a.7.7,0,0,1,.5.205l6.31,6.31a.7.7,0,0,1,.205.5V21.63a2.808,2.808,0,0,1-2.8,2.8H7.8A2.808,2.808,0,0,1,5,21.63V4.8A2.808,2.808,0,0,1,7.8,2Zm8.123,1.4H7.8A1.4,1.4,0,0,0,6.4,4.8V21.63a1.4,1.4,0,0,0,1.4,1.4H20.424a1.4,1.4,0,0,0,1.4-1.4V9.3Z",
    transform: "translate(-5 -2)",
    fill: "#2d5794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365580",
    "data-name": "Path 365580",
    d: "M27.011,9.712H20.7a.7.7,0,0,1-.7-.7V2.7a.7.7,0,1,1,1.4,0V8.31h5.609a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-9.484 -2)",
    fill: "#2d5794"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365581",
    "data-name": "Path 365581",
    d: "M20.114,19.9H11.7a.7.7,0,1,1,0-1.4h8.413a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-6.794 -6.932)",
    fill: "#2d5794"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365582",
    "data-name": "Path 365582",
    d: "M20.114,25.9H11.7a.7.7,0,1,1,0-1.4h8.413a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-6.794 -8.726)",
    fill: "#2d5794"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365583",
    "data-name": "Path 365583",
    d: "M13.8,13.9H11.7a.7.7,0,0,1,0-1.4h2.1a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-6.794 -5.139)",
    fill: "#2d5794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.bcee5e2f4f7138849a5ae3adfc205819.svg";
export { ForwardRef as ReactComponent };